import React, { useState } from 'react';
import { Menu } from 'lucide-react';
import { CoinsSection, AmountsSection } from '../components/BotSettings';
import { Sidebar } from '../components/Sidebar';

export const CoinsAmountsPage: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [quoteCurrency, setQuoteCurrency] = useState('USDT');
  const [selectedCoins, setSelectedCoins] = useState<string[]>([]);
  const [percentageAmount, setPercentageAmount] = useState(10);
  const [accountBalance, setAccountBalance] = useState(1000);
  const [minAmount, setMinAmount] = useState(10);
  const [useFixedAmount, setUseFixedAmount] = useState(false);
  const [maxAllocation, setMaxAllocation] = useState(1000);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 pt-16">
      {/* Mobile Menu Button */}
      <div className="md:hidden fixed top-20 left-4 z-50">
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="p-2 rounded-lg bg-white dark:bg-gray-800 shadow-lg border border-gray-200 dark:border-gray-700"
        >
          <Menu className="h-6 w-6 text-gray-600 dark:text-gray-300" />
        </button>
      </div>

      {/* Sidebar */}
      <Sidebar
        isMobileMenuOpen={isMobileMenuOpen}
        setIsMobileMenuOpen={setIsMobileMenuOpen}
      />

      {/* Main content */}
      <div className="md:ml-64 flex-1">
        <main className="p-4 md:p-8 mt-8 md:mt-0">
          <div className="w-full space-y-6">
            <div>
              <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
                Coins and Amounts
              </h1>
              <p className="text-gray-600 dark:text-gray-400 mb-8">
                Select a quote currency as well as the coins you want your bot to start trading.
              </p>
            </div>

            <CoinsSection
              quoteCurrency={quoteCurrency}
              onQuoteCurrencyChange={setQuoteCurrency}
              selectedCoins={selectedCoins}
              onSelectedCoinsChange={setSelectedCoins}
            />

            <AmountsSection
              quoteCurrency={quoteCurrency}
              selectedCoins={selectedCoins}
              percentageAmount={percentageAmount}
              onPercentageAmountChange={setPercentageAmount}
              accountBalance={accountBalance}
              onAccountBalanceChange={setAccountBalance}
              minAmount={minAmount}
              onMinAmountChange={setMinAmount}
              useFixedAmount={useFixedAmount}
              onUseFixedAmountChange={setUseFixedAmount}
              maxAllocation={maxAllocation}
              onMaxAllocationChange={setMaxAllocation}
            />
          </div>
        </main>
      </div>

      {/* Mobile menu overlay */}
      {isMobileMenuOpen && (
        <div
          className="md:hidden fixed inset-0 bg-black bg-opacity-50 z-30"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}
    </div>
  );
};
